
export default function (url) {
    return 'https://bots.fleetsoft.pro' + url
}